
import { Route } from '@/app/router'

const GroupedSalesDrafts = () => import('./index.vue')

const GroupedSalesDraftsMeta = {
	displayInSidebar: false,
	displayName: 'grouped-sales-drafts'

}

const GroupedSalesDraftsProps = ['page', 'perPage']

export default new Route('/grouped-sales-drafts', GroupedSalesDrafts)
	.as('Dashboard:GroupedSalesDrafts')
	.meta(GroupedSalesDraftsMeta)
	.props(GroupedSalesDraftsProps)
	.permissions(['SHOW_GROUPED_SALES', 'PROCESS_VIN'])
